export default "__VITE_ASSET__0DvQc$lu__"